export const initialPracticeTest: Partial<NewTestRequest> = {
  test_id: "",
  test_section_ids: [],
  assignment_date: "",
  due_date: null,
  is_timed: false,
  exclude_from_improvement: false,
  notify: false,
  notify_emails: ""
};

export const initialRealTest: Partial<Test> = {
  test_id: "",
  test_section_ids: [],
  assignment_date: "",
  due_date: null,
  is_timed: false,
  exclude_from_improvement: false,
  real_test: {
    link_to_test_pdf: null,
    link_to_bubble_sheet: null,
    test_assigned: false,
    test_due_reminder: false,
    personal_note: null,
    test_subject_ids: []
  }
};

export const initialPagination: Pagination = {
  page: 1,
  last_page: 1,
  per_page: 25,
  search: "",
  total: 0,
  from: 1,
  to: 25,
  sort_by: null,
  sort_type: null
};

export const initialSession: Partial<InitSession> = {
  end: "",
  notes: "",
  start: ""
};

export const UserProfileInitValue: FormDataUserProfile = {
  first_name: "",
  last_name: "",
  phone: "",
  email: "",
  city: "",
  state: "",
  zip: "",
  address: "",
  address_two: "",
  timezone: "",
  id: ""
};

export const StudentAccountSettingsInitValues: StudentAccount = {
  exclude_from_stats: false,
  active: false,
  prevent_login: false,
  archived: false
};

export const StudentCourseContextInitValues: StudentCourseContext = {
  course_end_date: "",
  course_start_date: "",
  graduation_year: "",
  high_school: "",
  target_score: 0
};

export const CourseFlags: CourseFlags = {
  exclude_from_stats: false,
  active: false,
  prevent_login: false
};

export const StudentCourseContext: CourseContext = {
  course_end_date: "",
  course_start_date: "",
  graduation_year: "",
  high_school: ""
};

export const studentProfile: Partial<UpdateStudent> = {
  first_name: "",
  last_name: "",
  email: "",
  timezone: ""
};

export const studentAddress: UpdateStudentAddress = {
  state: "",
  city: "",
  address: "",
  address_two: "",
  zip: "",
  phone: ""
};

export const instructorsState: InstructorsState = {
  newInstructors: [],
  removedInstructors: []
};

export const locationState: LocationsState = {
  newLocations: [],
  removedLocations: []
};

export const classroomsState: ClassroomsState = {
  newClassrooms: [],
  removedClassrooms: [],
  unassignStrategy: "KEEP_ALL",
  assignStrategy: "ALL"
};

export const initialClassroomSettingsInformations = {
  name: null,
  start_date: null,
  end_date: null,
  archived: false,
  exclude_from_statistics: false
};

export const initialClassroom: Partial<Classroom> = {
  archived: false,
  end_date: null,
  exclude_from_statistics: false,
  instructors: [],
  location: null,
  name: "",
  start_date: null,
  students: []
};

export const instructorInfoInit = {
  email: "",
  first_name: "",
  last_name: "",
  timezone: "",
  user_id: ""
};

export const instructorAddressInit = {
  address: "",
  address_two: "",
  city: "",
  phone: "",
  state: "",
  user_id: "",
  zip: ""
};

export const locationInfoInit = {
  location_id: "",
  organization_id: "",
  owner_id: "",
  name: "",
  nickname: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  phone: "",
  website: "",
  "email-signature": "",
  subdomain: ""
};

export const brandingInit = {
  color_1: "",
  color_2: "",
  background_color: "",
  color_logo: "",
  black_logo: "",
  bg_image: null
};

export const LocationImages: ImagesLocationCreate[] = [
  {
    id: "color_logo",
    imageFile: null,
    label: "Login Logo",
    imageURL: ""
  },
  {
    id: "black_logo",
    imageFile: null,
    label: "Header Logo",
    imageURL: ""
  },
  {
    id: "bg_image",
    imageFile: null,
    label: "Background Image",
    imageURL: ""
  }
];

export const newCourseTemplateInit = {
  name: "",
  description: "",
  sessions: []
};
